import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import Translator, { __ } from "services/Translator";


import api from "services/api";


import RankSystem from "./VIP/RankSystem";
import VipLevels from "./VIP/VipLevels";
import VIPClub from "./VIP/VIPClub";
import ProcessLevels from "./VIP/ProcessLevels";
import VipChart from "./VIP/VipChart";
import HomeFullBanner from "elements/HomeFullBanner";
import SeoContent from "components/SeoContent";
import VIPRewardsTierTable from "components/VIPRewardsTierTable";
import VIPFaqs from "components/VIPFaqs";
import { useIsAuthenticated } from "components/auth/AuthGate";
import { TeaserHero } from "components/auth/teaser";
import VipConversion from "components/vip/VipConversion";
import "styles/play365/_vipTeaser.scss";

export default function Vip(props) {
  const isAuthenticated = useIsAuthenticated();
  const [selectedLanguage, setSelectedLanguage] = useState({});

  const getSelectedLanguage = async () => {
    var lang = await Translator.getSelectedLanguage();
    setSelectedLanguage(lang);
  };

  //Get Banners
  const [banners, setBanners] = useState([]);
  const getBanners = async (ev) => {
    var response = await api.get("/vip-banners");
    setBanners(response.data);
  };

  useEffect(() => {
    getBanners();
    getSelectedLanguage();
  }, []);

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 10000,
    arrows: false,
    // slidesToShow: 1,
    // slidesToScroll: 1,
  };

  const [pageContent, setPageContent] = useState("");
  const getContentPage = async () => {
    var response = await api.get("/get-content-page", {
      page_uid: "vip",
    });

    if (response.status == 200) {
      setPageContent(response.data);
    }
  };

  useEffect(() => {
    getContentPage();
  }, []);

  // FAQ data for VIP Levels
  const vipFaqs = [
    {
      title: "How do I advance to the next VIP level?",
      description: "You advance to the next VIP level by earning points through your gameplay and purchases. Each tier requires a specific number of points to unlock. The more you play, the faster you'll progress through the VIP levels."
    },
    {
      title: "What benefits do I get at each VIP level?",
      description: "Each VIP level offers unique benefits including boosted rebates, exclusive bonuses, access to VIP tournaments, and special rewards. Higher levels unlock more prestigious perks such as VIP host access and custom VIP programs."
    },
    {
      title: "Do my points reset when I reach a new level?",
      description: "No, your points do not reset when you reach a new VIP level. Your progress continues to accumulate, allowing you to continue advancing through the tier system while enjoying the benefits of your current level."
    },
    {
      title: "How often are VIP bonuses distributed?",
      description: "VIP bonuses are distributed on different schedules depending on the type. Daily reloads are available daily, weekly bonuses are distributed weekly, and monthly bonuses are paid out once per month. The frequency increases with higher VIP levels."
    },
    {
      title: "Can I lose my VIP status?",
      description: "Once you've achieved a VIP level, you maintain that status. However, to access the benefits of higher tiers, you'll need to continue earning points through gameplay and purchases to reach those levels."
    }
  ];

  const renderHTML = (rawHTML) =>
    React.createElement("div", {
      dangerouslySetInnerHTML: { __html: rawHTML },
    });

  return (
    <>
      <div className="container-xxl">
        {isAuthenticated ? (
          <HomeFullBanner {...props} callFrom={"vip"} />
        ) : (
          <TeaserHero
            className="vip-hero"
            eyebrow={__("Clover Climber VIP Club")}
            title={__("Climb the Clover ranks. Play like royalty.")}
            subtitle={__(
              "Earn Clover Points on every real-money bet, rise through five tiers, and unlock boosted cashback, exclusive VIP tournaments and a dedicated host."
            )}
            align="start"
            setModalSignUpPropsData={props.setModalSignUpPropsData}
            setModalLoginPropsData={props.setModalLoginPropsData}
            signUpLabel={__("Join the Club")}
          >
            <p className="vip-teaser__legal">
              {__(
                "18+ only. Play responsibly. Terms & conditions apply. Available where permitted by law."
              )}
            </p>
          </TeaserHero>
        )}
        <div className="vipContainers">
          <RankSystem {...props} />
          <VIPRewardsTierTable />
          <VipConversion {...props} variant="mid" />
          {/* <ProcessLevels {...props} /> */}
          {/* <VipLevels {...props} /> */}
          {/* <VIPClub {...props} /> */}
          {/* <VipChart {...props} /> */}
        </div>

        <VIPFaqs {...props} vipFaqs={vipFaqs}/>
        <VipConversion {...props} variant="closer" />
        <SeoContent {...props} />
      </div>

    </>
  );
}
